<template>
  <MainLayout :showStatsSidebar="false">
    <div class="admin-layout">
      <div class="admin-sidebar">
        <v-card elevation="2" class="sidebar-card">
          <v-list>
            <v-list-item
              to="/admin/general"
              :active="$route.path === '/admin/general'"
              color="primary"
            >
              <template v-slot:prepend>
                <v-icon icon="mdi-cog" />
              </template>
              <v-list-item-title>General</v-list-item-title>
            </v-list-item>
            <v-list-item
              to="/admin/people"
              :active="$route.path === '/admin/people'"
              color="primary"
            >
              <template v-slot:prepend>
                <v-icon icon="mdi-account-group" />
              </template>
              <v-list-item-title>People</v-list-item-title>
            </v-list-item>
            <v-list-item
              to="/admin/rewards"
              :active="$route.path === '/admin/rewards'"
              color="primary"
            >
              <template v-slot:prepend>
                <v-icon icon="mdi-gift" />
              </template>
              <v-list-item-title>Rewards</v-list-item-title>
            </v-list-item>
            <v-list-item
              to="/admin/redemptions"
              :active="$route.path === '/admin/redemptions'"
              color="primary"
            >
              <template v-slot:prepend>
                <v-icon icon="mdi-gift-outline" />
              </template>
              <v-list-item-title>Redemptions</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </div>

      <!-- Main Content -->
      <div class="admin-content">
        <slot></slot>
      </div>
    </div>
  </MainLayout>
</template>

<script setup lang="ts">
import MainLayout from './MainLayout.vue'
</script>

<style scoped>
.admin-layout {
  display: flex;
  min-height: calc(100vh - 80px - 120px); /* Account for nav and footer */
  background: #f5f5f5;
}

.admin-sidebar {
  width: 280px;
  flex-shrink: 0;
  position: fixed;
  left: 0;
  top: 80px; /* Account for fixed navigation */
  height: calc(100vh - 80px - 120px); /* Account for nav and footer */
  z-index: 100;
  padding: 1rem;
}

.sidebar-card {
  height: 100%;
  border-radius: 12px;
}

.admin-content {
  flex: 1;
  margin-left: 280px; /* Account for fixed sidebar */
  padding: 2rem;
}

@media (max-width: 768px) {
  .admin-layout {
    flex-direction: column;
  }

  .admin-sidebar {
    position: static;
    width: 100%;
    height: auto;
    padding: 1rem;
  }

  .admin-content {
    margin-left: 0;
    padding: 1rem;
  }
}
</style> 